import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "contexts/Auth/AuthContext";
import useFirebaseAnalytics from "hooks/useFirebaseAnalytics";
import { useApplicationAction } from "contexts/ApplicationContext";
import NonAuth from "./NonAuth";
import NonAuthLayout from "App/Routes/NonAuth/components/Layout";
import { Alert, Button } from "@periplus/ui-library";

const useAnalytics = () => {
  const { analytics } = useFirebaseAnalytics();
  const auth = useAuth();
  const user = auth.user;
  const isAuthenticated = auth.isAuthenticated;
  const { i18n } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(useLocation().search);
  const appAction = useApplicationAction();

  const search = queryParams.get("q");

  useEffect(() => {
    /* eslint-disable no-restricted-globals */
    if (screen) {
      // @ts-ignore
      analytics.logEvent("screen_view", {
        screen_resolution: `${screen.width}x${screen.height}`,
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    analytics.setUserProperties({ guest: !isAuthenticated });

    if (isAuthenticated && user) {
      analytics.setUserProperties({ name: user.email });
      analytics.setUserId(user.userId);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, user]);

  useEffect(() => {
    const { pathname } = location;
    appAction.saveLocation(pathname);
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    const { pathname } = location;

    analytics.logEvent("page_view", {
      page_location: pathname,
      search,
      language: i18n.language,
    });
    // eslint-disable-next-line
  }, [location, i18n.language]);

  useEffect(() => {
    // @ts-ignore
    analytics.logEvent("search", { search_term: search });
    //eslint-disable-next-line
  }, []);
};

export default ({ children }: React.PropsWithChildren<any>) => {
  const { isAuthenticated, isAuthorized, logout } = useAuth();
  useAnalytics();
  const { t } = useTranslation();

  if (!isAuthenticated || !isAuthorized) return <NonAuth />;

  return <Switch>
    <Route
      path="/reset-password"
      exact
      component={() => (
        <NonAuthLayout>
          <Alert severity="error">{t("You are already signed in")}</Alert>
          <Button variant="primary" onClick={logout}>{t("logout")}</Button>
        </NonAuthLayout>
      )}
    />
    {children}
  </Switch>;
};
